import {Grid, GridItem} from "@consta/uikit/Grid";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import "../css/pageGraph.css";
import GridGraphGraphList from "./component/grid.graph.graphList";
import {startOfMonth} from "date-fns";
import {ChoiceGroup} from '@consta/uikit/ChoiceGroup';
import {DatePicker} from "@consta/uikit/DatePicker";
import AgExportCmp from "./component/export.graph.func";
import {cn} from "@consta/uikit/__internal__/src/uiKit/cn";
import moment from "moment/moment";
import {API_GRAPH_EXIST_MONTH, API_GRAPH_LIST} from "../../service/api.endpoint";
import GraphWellHistoryModal from "./component/modal.graph.wellHistory";
import GraphWellHistorySearchModal from "./component/modal.graph.wellHistorySearch";
import {v4 as uuidv4} from "uuid";
import GetTaskResult from "../../component/result.dramatiq.cmp";
import {canUseModule, getStoredAccess, isBusinessAdmin} from "../../service/authAccess";
import http from "../../service/axiosConfig";


const PageGraph = () => {
    const [valueDate, setValueDate] = useState<Date | null>(null);
    const [rowDataTransfer, setRowDataTransfer] = useState<any>(null);
    const [valueMonthChoice, setValueMonthChoice] = useState<Item | null>(null);
    const [filterDate, setFilterDate] = useState<Date | 'loading' | null>(null)
    const [graphLoading, setGraphLoading] = useState<boolean>(false)
    const [historyWell, setHistoryWell] = useState<any>(null)
    const [isHistorySearchOpen, setIsHistorySearchOpen] = useState(false)
    const access = useMemo(() => getStoredAccess(), []);
    const canExportGraph = canUseModule('graph', access);
    const canManageGraph = isBusinessAdmin(access);
    type Item = { name: string; disabled?: boolean, numeric?: string };
    const cnChoiceGroupExampleAdaptiveScroll = cn(
        'ChoiceGroupExampleAdaptiveScroll',
    );
    const [itemsMonth, setItemsMonth] = useState<Item[]>([
        {name: 'январь', numeric: '01', disabled: true},
        {name: 'февраль', numeric: '02', disabled: true},
        {name: 'март', numeric: '03', disabled: true},
        {name: 'апрель', numeric: '04', disabled: true},
        {name: 'май', numeric: '05', disabled: true},
        {name: 'июнь', numeric: '06', disabled: true},
        {name: 'июль', numeric: '07', disabled: true},
        {name: 'август', numeric: '08', disabled: true},
        {name: 'сентябрь', numeric: '09', disabled: true},
        {name: 'октябрь', numeric: '10', disabled: true},
        {name: 'ноябрь', numeric: '11', disabled: true},
        {name: 'декабрь', numeric: '12', disabled: true},
        {name: 'найти...', numeric: 'find', disabled: false},
        {name: 'экспорт', numeric: 'exp', disabled: true},

    ])
    useEffect(() => {
        document.title = 'АСПО.Контроль | График';
    }, []);

    useEffect(() => {
        const currentDate = startOfMonth(new Date());
        setValueDate(currentDate);
    }, []);

    useEffect(() => {
        if (valueDate) {
            http.get(API_GRAPH_EXIST_MONTH, {params: {year: moment(valueDate).format("YYYY")}})
                .then((response) => {
                    const data = response.data.result;
                    const updatedItemsMonth = itemsMonth.map(el => {
                        if (data.includes(el.numeric)) {
                            if (graphLoading) {
                                return {...el, disabled: true}
                            } else {
                                return {...el, disabled: false}
                            }
                        } else {
                            if (el.numeric === 'find' && !graphLoading) {
                                return {...el, disabled: false}
                            } else if (el.numeric === 'exp' && filterDate && !graphLoading && canExportGraph) {
                                return {...el, disabled: false}
                            } else if (el.numeric === 'imp' && canManageGraph) {
                                return {...el, disabled: false}
                            }
                            return {...el, disabled: true}
                        }
                    });
                    setItemsMonth(updatedItemsMonth);
                });
        }
    }, [valueDate, filterDate, graphLoading, canExportGraph, canManageGraph]);

    const blurActiveControl = () => {
        window.requestAnimationFrame(() => {
            const activeElement = document.activeElement
            if (activeElement instanceof HTMLElement) {
                activeElement.blur()
            }
        })
    }

    const loadFullGraphForExport = async () => {
        if (!filterDate) {
            return []
        }
        if (rowDataTransfer) {
            return rowDataTransfer
        }

        setGraphLoading(true)
        const requestId = uuidv4()
        const formattedDate = filterDate.toLocaleString("ru-RU", {timeZone: "Asia/Yekaterinburg"});
        const response = await http.get(API_GRAPH_LIST, {
            params: {
                date: formattedDate,
                requestId: requestId,
            }
        });

        if (response.data['status'] === 'DONE') {
            setRowDataTransfer(response.data['data'] || [])
            setGraphLoading(false)
            return response.data['data'] || []
        }

        const fetchResult = async (): Promise<any[]> => {
            const resultTask = await GetTaskResult(requestId)
            if (!resultTask.data) {
                await new Promise(resolve => setTimeout(resolve, 2000))
                return fetchResult()
            }
            setRowDataTransfer(resultTask.data || [])
            return resultTask.data || []
        }

        try {
            return await fetchResult()
        } finally {
            setGraphLoading(false)
        }
    }

    const handleMonthChange = async (value: any) => {
        blurActiveControl()

        if (value.numeric === 'exp') {
            const exportData = await loadFullGraphForExport()
            AgExportCmp({data: exportData})
        } else if (value.numeric === 'find') {
            setIsHistorySearchOpen(true)
        } else {
            setFilterDate(null)
            setRowDataTransfer(null)
            setValueMonthChoice(value)
            const toDate = moment(`${moment(valueDate).format("YYYY")}-${value.numeric}-01`).toDate();
            setFilterDate(toDate)
        }
    }
    const handleLoadingGraph = useCallback((loading: boolean) => {
        setGraphLoading(loading)
    }, [])

    const openHistoryWell = (well: any) => {
        setHistoryWell(well)
    }

    return (
        <>
            <Grid className="gridMain" cols="2" gap="2xs">
                <GridItem col={1}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <DatePicker
                            id='year'
                            style={{paddingRight: '5px'}}
                            // style={{zIndex: 2}}
                            size={'s'}
                            type="year"
                            value={valueDate}
                            onChange={({value}) => setValueDate(value)}
                        />
                        <div className={cnChoiceGroupExampleAdaptiveScroll()}>
                            <ChoiceGroup
                                value={valueMonthChoice}
                                onChange={({value}) => handleMonthChange(value)}
                                items={itemsMonth}
                                size={'s'}
                                getItemLabel={(item) => item.name}
                                name="ChoiceGroupExampleSomeDisabled"
                                getItemDisabled={(item: Item) => item.disabled}
                                width='full'
                                disabled={graphLoading}
                            />

                        </div>

                    </div>
                </GridItem>
                {/*<GridItem style={{display: "flex", justifySelf: "end"}}>*/}
                {/*    /!*<AgExportCmp data={rowDataTransfer}/>*!/*/}
                {/*    */}
                {/*</GridItem>*/}
                <GridItem col={2}>
                    {filterDate && <GridGraphGraphList date={filterDate} rowDataTransfer={rowDataTransfer}
                                                       setRowDataTransfer={setRowDataTransfer} loading={handleLoadingGraph}/>}
                </GridItem>
            </Grid>
            {isHistorySearchOpen && (
                <GraphWellHistorySearchModal
                    onClose={() => setIsHistorySearchOpen(false)}
                    onSelect={openHistoryWell}
                />
            )}
            {historyWell && (
                <GraphWellHistoryModal
                    row={historyWell}
                    onClose={() => setHistoryWell(null)}
                />
            )}

        </>
    );
}

export default PageGraph;
